import ChartCard from '../common/ChartCard';
import DonutChart from './DonutChart';
import useMetric from '../../hooks/useMetric';
import { formatPercent } from '../../utils/format';

export default function SupportResolutionChart() {
  const { status, data, error, retry } = useMetric('supportResolution');
  const total = data ? data.resolved + data.inProgress + data.handover : 0;
  return (
    <ChartCard
      testId="chart-support-resolution" title="Support Resolution" subtitle={data && total ? `${formatPercent((data.resolved / total) * 100)} resolved` : 'Resolution breakdown'}
      status={status === 'success' && total === 0 ? 'empty' : status} error={error} onRetry={retry}
      emptyText="No support conversations in this period."
    >
      {total > 0 && (
        <DonutChart
          centerLabel="Total"
          segments={[
            { label: 'Resolved', value: data.resolved, color: '#28A745' },
            { label: 'In Progress', value: data.inProgress, color: '#FFC107' },
            { label: 'Human Handover', value: data.handover, color: '#DC3545' },
          ]}
        />
      )}
    </ChartCard>
  );
}
